export default __webpack_public_path__ + "cc21a611a249a0fcbc23309aa7739fa6.svg";